"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A class to bundle all of the loosely coupled service definitions together
 * and allows for configuration and logging to be controlled in one place
 *
 * @author Masahji C. Stewart
 */
var CoreService = /*#__PURE__*/function () {
  function CoreService() {
    var services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, CoreService);
    this._services = _objectSpread({}, services);
    this._api = new Proxy(this._services, {
      set: function set(obj, prop) {
        throw new ReferenceError("api ".concat(prop, " cannot be set"));
      }
    });
  }

  (0, _createClass2["default"])(CoreService, [{
    key: "clone",
    value: function clone() {
      var c = new CoreService(this._services);
      return c;
    }
    /**
     * @returns a read only object which can access all services defined in this SDK
     *
     * @example
     * coreServiceInstance.api.someService.blahServiceMethod()
     *
     *
     */

  }, {
    key: "register",

    /**
     * @param {string} serviceName
     * @param {string} serviceInstance
     *
     * "registers" (defines) the serviceName as the serviceInstance within this.api
     * registration also means that serviceInstance will be have its `core` instance
     * set to `this`
     *
     * @example
     * coreServiceInstance.register('example', new ExampleService());
     * coreServiceInstance.api.example.someExampleServiceMethod();
     */
    value: function register(serviceName, serviceInstance) {
      this._services[serviceName] = serviceInstance;
      serviceInstance.core = this;
    }
  }, {
    key: "api",
    get: function get() {
      return this._api;
    }
  }, {
    key: "requestAdapter",
    set: function set(adapter) {
      this._requestAdapter = adapter;
    },
    get: function get() {
      return this._requestAdapter;
    }
  }]);
  return CoreService;
}();

exports["default"] = CoreService;